module.exports = __webpack_public_path__ + "static/media/signedTrue.3fcb46ec.svg";